
































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { CreditCardAssignment } from "@scrile/api-provider/dist/api/CreditCardAssignmentsProvider";
import { RecurringBillingSchedule } from "@scrile/api-provider/dist/api/RecurringBillingScheduleProvider";
import { Subscription } from "@scrile/api-provider/dist/api/SubscriptionProvider";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseImage from "@/components/BaseImage";
import BasePage from "@/components/BasePage";
import EmptyContent from "@/components/EmptyContent";
import InfiniteScroll from "@/components/InfiniteScroll";
import PageTitle from "@/components/PageTitle";
import CancelConfirm from "../CancelConfirm";
import SubscriptionItemView from "../SubscriptionItem";

@Component({
  name: "PageManageRecurringView",
  components: { CancelConfirm, InfiniteScroll, BasePage, PageTitle, BaseConfirm, EmptyContent, BaseImage, BaseButton },
})
export default class PageManageRecurringView extends Vue {
  @Prop({ type: Boolean, required: true })
  public readonly loading!: boolean;

  @Prop({ type: Boolean, required: true })
  public readonly canceling!: boolean;

  @Prop({ type: Boolean, required: true })
  public readonly enableScroll!: boolean;

  @Prop({ required: true })
  public readonly creditCard!: CreditCardAssignment | null;

  @Prop({ type: Array, required: true })
  public readonly list!: Subscription[];

  public subscriptionItemView = SubscriptionItemView;

  public cancelRecurring: RecurringBillingSchedule | null = null;

  public cancelTitle: string = "";

  public cancelDescription: string = "";

  public cancelCb: Function = () => {};

  public get cancelShowConfirm(): boolean {
    return !!this.cancelRecurring;
  }

  public onCancel(
    {
      recurring,
      title,
      description,
    }: {
      recurring: RecurringBillingSchedule;
      title: string;
      description: string;
    },
    cb: Function
  ) {
    this.cancelRecurring = recurring;
    this.cancelDescription = description;
    this.cancelTitle = title;
    this.cancelCb = () => {
      cb();
      this.cancelRecurring = null;
      this.cancelDescription = "";
      this.cancelTitle = "";
      this.cancelCb = () => {};
    };
  }

  public onConfirmInput(status: boolean) {
    if (status) {
      this.$emit("cancel", this.cancelRecurring, () => this.cancelCb());
    } else this.cancelCb();
  }
}
